import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from './PrimaryButton';
import ProjectMedia from './ProjectMedia';

const ProjectCard = ({ title, description, image, imageAlt, link, reverse = false }) => {
    const navigate = useNavigate();

    return (
        <article className="w-full overflow-hidden rounded-2xl border border-earth-200 bg-earth-100/70 dark:border-earth-700 dark:bg-earth-800/80">
            <div className="grid grid-cols-1 md:grid-cols-2 md:h-[360px] lg:h-[380px] md:items-stretch">
                <div className={`${reverse ? 'md:order-2' : 'md:order-1'} flex h-full flex-col justify-between gap-5 p-6 sm:p-8 lg:p-10`}>
                    <div className="space-y-5">
                        <h3 className="text-2xl sm:text-3xl font-bold text-earth-900 dark:text-earth-50 leading-tight">
                            {title}
                        </h3>
                        <p className="text-base sm:text-lg text-earth-700 dark:text-earth-100 leading-relaxed">
                            {description}
                        </p>
                    </div>
                    <PrimaryButton className="w-fit" onClick={() => navigate(link)}>
                        View Project
                    </PrimaryButton>
                </div>

                <div className={`${reverse ? 'md:order-1' : 'md:order-2'} h-full min-h-[240px] sm:min-h-[280px] md:min-h-full`}>
                    <ProjectMedia src={image} alt={imageAlt} />
                </div>
            </div>
        </article>
    );
};

export default ProjectCard;
